export const SET_OFFER_STATE = 'SET_OFFER_STATE';
export const INCREASE_OFFER_COUNT = 'INCREASE_OFFER_COUNT';
export const REDUCE_OFFER_COUNT = 'REDUCE_OFFER_COUNT';
